import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import './actionbar.css';
import * as platform from '../../../common/platform.js';
import * as nls from '../../../../nls.js';
import { Disposable } from '../../../common/lifecycle.js';
import { Action, ActionRunner, Separator } from '../../../common/actions.js';
import * as DOM from '../../dom.js';
import * as types from '../../../common/types.js';
import { EventType, Gesture } from '../../touch.js';
import { DataTransfers } from '../../dnd.js';
import { isFirefox } from '../../browser.js';
export var BaseActionViewItem = /*#__PURE__*/function (_Disposable) {
  _inherits(BaseActionViewItem, _Disposable);

  var _super = _createSuper(BaseActionViewItem);

  function BaseActionViewItem(context, action) {
    var _this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, BaseActionViewItem);

    _this = _super.call(this);
    _this.options = options;
    _this._context = context || _assertThisInitialized(_this);
    _this._action = action;

    if (action instanceof Action) {
      _this._register(action.onDidChange(function (event) {
        if (!_this.element) {
          // we have not been rendered yet, so there
          // is no point in updating the UI
          return;
        }

        _this.handleActionChangeEvent(event);
      }));
    }

    return _this;
  }

  _createClass(BaseActionViewItem, [{
    key: "handleActionChangeEvent",
    value: function handleActionChangeEvent(event) {
      if (event.enabled !== undefined) {
        this.updateEnabled();
      }

      if (event.checked !== undefined) {
        this.updateChecked();
      }

      if (event.class !== undefined) {
        this.updateClass();
      }

      if (event.label !== undefined) {
        this.updateLabel();
        this.updateTooltip();
      }

      if (event.tooltip !== undefined) {
        this.updateTooltip();
      }
    }
  }, {
    key: "actionRunner",
    get: function get() {
      if (!this._actionRunner) {
        this._actionRunner = this._register(new ActionRunner());
      }

      return this._actionRunner;
    },
    set: function set(actionRunner) {
      this._actionRunner = actionRunner;
    }
  }, {
    key: "getAction",
    value: function getAction() {
      return this._action;
    }
  }, {
    key: "isEnabled",
    value: function isEnabled() {
      return this._action.enabled;
    }
  }, {
    key: "setActionContext",
    value: function setActionContext(newContext) {
      this._context = newContext;
    }
  }, {
    key: "render",
    value: function render(container) {
      var _this2 = this;

      var element = this.element = container;

      this._register(Gesture.addTarget(container));

      var enableDragging = this.options && this.options.draggable;

      if (enableDragging) {
        container.draggable = true;

        if (isFirefox) {
          // Firefox: requires to set a text data transfer to get going
          this._register(DOM.addDisposableListener(container, DOM.EventType.DRAG_START, function (e) {
            var _a;

            return (_a = e.dataTransfer) === null || _a === void 0 ? void 0 : _a.setData(DataTransfers.TEXT, _this2._action.label);
          }));
        }
      }

      this._register(DOM.addDisposableListener(element, EventType.Tap, function (e) {
        return _this2.onClick(e);
      }));

      this._register(DOM.addDisposableListener(element, DOM.EventType.MOUSE_DOWN, function (e) {
        if (!enableDragging) {
          DOM.EventHelper.stop(e, true); // do not run when dragging is on because that would disable it
        }

        if (_this2._action.enabled && e.button === 0) {
          DOM.addClass(element, 'active');
        }
      }));

      if (platform.isMacintosh) {
        // macOS: allow to trigger the button when holding Ctrl+key and pressing the
        // main mouse button. This is for scenarios where e.g. some interaction forces
        // the Ctrl+key to be pressed and hold but the user still wants to interact
        // with the actions (for example quick access in quick navigation mode).
        this._register(DOM.addDisposableListener(element, DOM.EventType.CONTEXT_MENU, function (e) {
          if (e.button === 0 && e.ctrlKey === true) {
            _this2.onClick(e);
          }
        }));
      }

      this._register(DOM.addDisposableListener(element, DOM.EventType.CLICK, function (e) {
        DOM.EventHelper.stop(e, true); // menus do not use the click event

        if (!(_this2.options && _this2.options.isMenu)) {
          platform.setImmediate(function () {
            return _this2.onClick(e);
          });
        }
      }));

      this._register(DOM.addDisposableListener(element, DOM.EventType.DBLCLICK, function (e) {
        DOM.EventHelper.stop(e, true);
      }));

      [DOM.EventType.MOUSE_UP, DOM.EventType.MOUSE_OUT].forEach(function (event) {
        _this2._register(DOM.addDisposableListener(element, event, function (e) {
          DOM.EventHelper.stop(e);
          DOM.removeClass(element, 'active');
        }));
      });
    }
  }, {
    key: "onClick",
    value: function onClick(event) {
      var _a;

      DOM.EventHelper.stop(event, true);
      var context = types.isUndefinedOrNull(this._context) ? ((_a = this.options) === null || _a === void 0 ? void 0 : _a.useEventAsContext) ? event : undefined : this._context;
      this.actionRunner.run(this._action, context);
    }
  }, {
    key: "focus",
    value: function focus() {
      if (this.element) {
        this.element.focus();
        DOM.addClass(this.element, 'focused');
      }
    }
  }, {
    key: "blur",
    value: function blur() {
      if (this.element) {
        this.element.blur();
        DOM.removeClass(this.element, 'focused');
      }
    }
  }, {
    key: "updateEnabled",
    value: function updateEnabled() {// implement in subclass
    }
  }, {
    key: "updateLabel",
    value: function updateLabel() {// implement in subclass
    }
  }, {
    key: "updateTooltip",
    value: function updateTooltip() {// implement in subclass
    }
  }, {
    key: "updateClass",
    value: function updateClass() {// implement in subclass
    }
  }, {
    key: "updateChecked",
    value: function updateChecked() {// implement in subclass
    }
  }, {
    key: "dispose",
    value: function dispose() {
      if (this.element) {
        DOM.removeNode(this.element);
        this.element = undefined;
      }

      _get(_getPrototypeOf(BaseActionViewItem.prototype), "dispose", this).call(this);
    }
  }]);

  return BaseActionViewItem;
}(Disposable);
export var ActionViewItem = /*#__PURE__*/function (_BaseActionViewItem) {
  _inherits(ActionViewItem, _BaseActionViewItem);

  var _super2 = _createSuper(ActionViewItem);

  function ActionViewItem(context, action) {
    var _this3;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, ActionViewItem);

    _this3 = _super2.call(this, context, action, options);
    _this3.options = options;
    _this3.options.icon = options.icon !== undefined ? options.icon : false;
    _this3.options.label = options.label !== undefined ? options.label : true;
    _this3.cssClass = '';
    return _this3;
  }

  _createClass(ActionViewItem, [{
    key: "render",
    value: function render(container) {
      _get(_getPrototypeOf(ActionViewItem.prototype), "render", this).call(this, container);

      if (this.element) {
        this.label = DOM.append(this.element, DOM.$('a.action-label'));
      }

      if (this.label) {
        if (this._action.id === Separator.ID) {
          this.label.setAttribute('role', 'presentation'); // A separator is a presentation item
        } else {
          if (this.options.isMenu) {
            this.label.setAttribute('role', 'menuitem');
          } else {
            this.label.setAttribute('role', 'button');
          }
        }
      }

      if (this.options.label && this.options.keybinding && this.element) {
        DOM.append(this.element, DOM.$('span.keybinding')).textContent = this.options.keybinding;
      }

      this.updateClass();
      this.updateLabel();
      this.updateTooltip();
      this.updateEnabled();
      this.updateChecked();
    }
  }, {
    key: "focus",
    value: function focus() {
      _get(_getPrototypeOf(ActionViewItem.prototype), "focus", this).call(this);

      if (this.label) {
        this.label.focus();
      }
    }
  }, {
    key: "updateLabel",
    value: function updateLabel() {
      if (this.options.label && this.label) {
        this.label.textContent = this.getAction().label;
      }
    }
  }, {
    key: "updateTooltip",
    value: function updateTooltip() {
      var title = null;

      if (this.getAction().tooltip) {
        title = this.getAction().tooltip;
      } else if (!this.options.label && this.getAction().label && this.options.icon) {
        title = this.getAction().label;

        if (this.options.keybinding) {
          title = nls.localize({
            key: 'titleLabel',
            comment: ['action title', 'action keybinding']
          }, "{0} ({1})", title, this.options.keybinding);
        }
      }

      if (title && this.label) {
        this.label.title = title;
      }
    }
  }, {
    key: "updateClass",
    value: function updateClass() {
      if (this.cssClass && this.label) {
        DOM.removeClasses(this.label, this.cssClass);
      }

      if (this.options.icon) {
        this.cssClass = this.getAction().class;

        if (this.label) {
          DOM.addClass(this.label, 'codicon');

          if (this.cssClass) {
            DOM.addClasses(this.label, this.cssClass);
          }
        }

        this.updateEnabled();
      } else {
        if (this.label) {
          DOM.removeClass(this.label, 'codicon');
        }
      }
    }
  }, {
    key: "updateEnabled",
    value: function updateEnabled() {
      if (this.getAction().enabled) {
        if (this.label) {
          this.label.removeAttribute('aria-disabled');
          DOM.removeClass(this.label, 'disabled');
          this.label.tabIndex = 0;
        }

        if (this.element) {
          DOM.removeClass(this.element, 'disabled');
        }
      } else {
        if (this.label) {
          this.label.setAttribute('aria-disabled', 'true');
          DOM.addClass(this.label, 'disabled');
          DOM.removeTabIndexAndUpdateFocus(this.label);
        }

        if (this.element) {
          DOM.addClass(this.element, 'disabled');
        }
      }
    }
  }, {
    key: "updateChecked",
    value: function updateChecked() {
      if (this.label) {
        if (this.getAction().checked) {
          DOM.addClass(this.label, 'checked');
        } else {
          DOM.removeClass(this.label, 'checked');
        }
      }
    }
  }]);

  return ActionViewItem;
}(BaseActionViewItem);